// Shared inline styles for the Site Builder SEO editors (SEOPanel.tsx for component sites,
// ImportedPageSEOPanel.tsx for imported-static sites). Extracted here so the two panels stay
// pixel-identical rather than drifting — see specs/completed/sitemap-llms-seo-metadata.md
// Phase 4 CSS Notes ("copy those three style objects verbatim … import from both").
//
// All colours via CSS variables — no hex literals, per the design system.
import React from 'react';

export const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '8px 10px',
  border: '1px solid var(--stroke, rgba(15,23,42,0.10))',
  borderRadius: 6,
  background: 'var(--input-bg, rgba(255,255,255,0.6))',
  color: 'var(--text)',
  fontSize: '0.8125rem',
  outline: 'none',
  boxSizing: 'border-box',
};

export const labelStyle: React.CSSProperties = {
  display: 'block',
  fontSize: '0.75rem',
  fontWeight: 600,
  color: 'var(--text-secondary)',
  marginBottom: 4,
  letterSpacing: '0.02em',
};

export const fieldWrapStyle: React.CSSProperties = {
  marginBottom: 14,
};
